import React from 'react'
import { withRouter } from 'router'

interface PublicLayoutProps {
  children: React.ReactNode
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return children
}

export default withRouter(PublicLayout)
